import { h, Component } from 'preact';
import style from './style';

var classNames = require('classnames/bind');
var cx = classNames.bind(style);

import { route } from 'preact-router';

import { apiGetRequest } from '../../../components/utils/api';
import Header from '../../../components/header';
import Back from '../../../components/back';
import Input from '../../../components/search/input';
import SearchResultCard from '../../../components/search/searchResultCard';
import SpecificDatePicker from '../../../components/search/datePickers/specificDatePicker';
import RangeDatePicker from '../../../components/search/datePickers/rangeDatePicker';
import Rate from '../../../components/search/rate';

import Dropdown from 'react-dropdown';

import Collapsible from 'react-collapsible';

import Select from 'react-select';
import AsyncSelect from 'react-select/lib/Async';
import 'react-day-picker/lib/style.css';

const qs = require('query-string');

const ClearIndicator = (props) => {
    const { getStyles, innerProps: { ref, ...restInnerProps } } = props;
    return (
        <div {...restInnerProps} ref={ref} style={getStyles('clearIndicator', props)}>
            <div style={{ padding: '0px 5px' }}>
                Clear
            </div>
        </div>
    );
};

const Option = (props) => {
    const { getStyles, innerProps: { ref, ...restInnerProps } } = props;
    let label = null;
    if (props.data.hasOwnProperty("doc_count")) {
        label = <p>{props.data.key} - <strong>{props.data.doc_count}</strong></p>
    } else {
        label = <p>{props.label}</p>
    }
    return (
        <div {...restInnerProps} ref={ref} style={getStyles("option", props)}>
            {label}
        </div>
    )
}

class Trigger extends Component {
    render() {
        return (
            <div style={{fontWeight: "bold", cursor: 'pointer'}} class={cx("collapse-trigger")}>
                <p>{this.props.trigger}</p>
                <i class={cx("fa fa-caret-down")} />
            </div>
        )    
    }
}

class TriggerOpen extends Component {
    render() {
        return (
            <div style={{fontWeight: "bold", cursor: 'pointer'}} class={cx("collapse-trigger")}>
                <p>{this.props.trigger}</p>
                <i class={cx("fa fa-caret-up")} />
            </div>
        )    
    }
}

const FilterContainer = (props) => {
    let renderPlaylistOptions = () => {
        if (props.playlistFacets.length == 0) {
            return props.searchEngine.providers[0].playlists.map((item) => (
                <option key={item} value={item}>{item}</option>
            ))
        } else {
            return props.playlistFacets.map((item) => (
                <option key={item.key} value={item.key}>{item.key} - {item.doc_count}</option>
            ))
        }
    }

    let renderVideoLabel = (item) => {
        if (item.hasOwnProperty("doc_count")) {
            return `${item.key} - <strong>${item.doc_count}</strong>`;
        } else {
            return item.label
        }
    }
    
    let getVideoValue = (item) => {
        if (item.hasOwnProperty("doc_count")) {
            return item.key;
        } else {
            return item.value
        }
    }

    return (
        <div class={cx("filterContainer")}>
            <Collapsible
                trigger={<Trigger trigger="Date Filter" />}
                triggerWhenOpen={<TriggerOpen trigger="Date Filter" />} 
                transitionTime={333}
                overflowWhenOpen={"visible"} 
                contentInnerClassName={cx("collapse-content-innner")}
                onOpening={() => props.mixpanel.track("Opened Date Filter")}
            >
                <div style={{width: "70%", margin: "auto"}}>
                    <Select
                        value={props.dateOption}
                        onChange={(value) => {
                            var date = undefined;
                            if (value.value == "range") {
                                date = {from: undefined, to: undefined}
                            }

                            props.mixpanel.track("Set Date Type", {type: value.value})

                            props.setState({dateOption: value, selectedDate: date});
                        }}
                        options={[
                            { value: '', label: 'Any Time' },
                            { value: 'specific', label: 'Specific Date' },
                            { value: 'range', label: 'Custom Range' },
                        ]}
                        getOptionLabel={(val) => val.label}
                        getOptionValue={(val) => val.value}
                        isSearchable={false}
                    />
                </div>
                {props.dateOption.value == "specific" &&
                    <SpecificDatePicker 
                        selectedDate={props.selectedDate}
                        onDayClick={(date) => {
                            props.setState({selectedDate: date}, () => {
                                props.queryStringCall();
                            })
                        }}
                        month={props.month}
                        handleYearMonthChange={(month) => {
                            props.handleYearMonthChange(month)
                        }}
                        buttonClass={cx("button")}
                        disabledDays={[
                            {
                                after: new Date(),
                            },
                        ]}
                        enabledDays={props.enabledDays}
                        earliestDate={props.earliestDate}
                        latestDate={props.latestDate}
                    />
                }
                {props.dateOption.value === "range" &&
                    <RangeDatePicker 
                        onDayClick={(date) => {
                            props.setState({selectedDate: date}, () => {
                                props.queryStringCall();
                            });
                        }}
                        selectedDate={props.selectedDate}
                        month={props.month}
                        handleYearMonthChange={(month) => props.handleYearMonthChange(month)}
                        buttonClass={cx("button")}
                        disabledDays={[
                            {
                                after: new Date(),
                            },
                        ]}
                        enabledDays={props.enabledDays}
                        earliestDate={props.earliestDate}
                        latestDate={props.latestDate}
                    />
                }
            </Collapsible>
            <Collapsible
                trigger={<Trigger trigger="Playlist Filter" />}
                triggerWhenOpen={<TriggerOpen trigger="Playlist Filter" />} 
                transitionTime={333}
                overflowWhenOpen={"visible"} 
                onOpening={() => props.mixpanel.track("Opened Playlist Filter")}
            >
                <div>
                    <select style={{width: "100%"}} placeholder="Select Playlist" onChange={this.change} value={props.playlistFilter} onChange={(event) => {
                        props.setState({playlistFilter: event.target.value}, () => {
                            props.queryStringCall();
                        })
                    }}>
                        <option disabled selected value="">Select Playlist</option>
                        {renderPlaylistOptions()}
                    </select>
                </div>
            </Collapsible>
            <div class={cx("filter-buttons")}>
                <button class={cx("button-base")} onClick={() => props.resetFilters()} disabled={props.isFilterButtonDisabled()}>
                    Reset Filters
                </button>
            </div>
        </div>
    )
};

export default class Search extends Component {
	constructor(props) {
        super(props);
        this.state = {
            searchValue: "",
            searchResults: [],
            searchEngine: {},
            page: 1,
            pages: 1,
            nextPageLoad: false,
            sort: { value: '', label: 'Sort by Relevance' },
            playlistFilter: "",
            videoFilter: "",
            dateOption: { value: '', label: 'Any Time' },
            selectedDate: undefined,
            month: new Date(),
            loading: true,
            emptySearch: false,
            resultCount: 0,
            enabledDays: [],
            earliestDate: null,
            latestDate: null,
            playlistFacets: [],
            videoFacets: []
        }
    }

    handleYearMonthChange(month) {
        this.setState({ month });
    }
    
    componentDidMount() {
        this.getSearchEngine();
    }

    getEnabledDays(data) {
        if (data.aggs.video.hasOwnProperty("date_range")) {
            let dates = data.aggs.video.date_range;
            let enabledDays = [];
            let earliestDate = null;
            let latestDate = null;
            dates.forEach((item) => {
                if (item.doc_count != 0) {
                    let date_obj = new Date(item.key);
                    date_obj.setHours(12);
                    if (earliestDate == null) {
                        earliestDate = date_obj
                    }
                    if (latestDate == null) {
                        latestDate = date_obj
                    }
                    if (date_obj <= earliestDate) {
                        earliestDate = date_obj
                    }
                    if (date_obj >= latestDate) {
                        latestDate = date_obj
                    }
                    enabledDays.push(date_obj.toString());
                }
            });
    
            earliestDate = new Date(earliestDate.getFullYear(), 0, 0);
    
            this.setState({enabledDays: enabledDays, earliestDate, latestDate, month: latestDate}, () => {
                // setTimeout(() => {
                //     this.setState({month: latestDate});
                // }, 100);
            });
        }
    }

    getSearchEngine() {
        this.props.changeAppLoading(true);
        apiGetRequest("search/retrieve/" + this.props.id, "", true, this.props.authToken).then((data) => {
            console.log(data);
            this.setState({searchEngine: data, loading: false});
            this.props.changeAppLoading(false);
        }).catch((error) => {
            console.log(error);
            this.props.changeAppLoading(false);
        })
    }

    search(nextPage = false) {
        this.setState({nextPageLoad: true});
        if (nextPage) {
            var elem = document.getElementById("resultsContainer");
            setTimeout(() => {
                elem.scrollTo(0, elem.scrollHeight);
            }, 33);
        }

        apiGetRequest("search/dsl-search/?" + this.state.qsString).then((data) => {
            console.log("Search Results:", data);
            if (nextPage) {
                var results = this.state.searchResults;
                var newResults = data.results;

                results = results.concat(newResults);
				this.setState({searchResults: results, nextPageLoad: false});
            } else {
                var pages = Math.ceil(data.count / 10);

                let state = {searchResults: data.results, pages: pages, nextPageLoad: false, resultCount: data.count};
                
                if (data.results.length == 0) {
                    state.emptySearch = true;
                };

                if (data.aggs.video.hasOwnProperty("video_title_count")) {
                    state.videoFacets = data.aggs.video.video_title_count
                }

                if (this.state.playlistFilter.length == 0 && this.state.playlistFacets.length == 0) {
                    state.playlistFacets = data.aggs.playlist;
                }
                
                this.setState(state, () => {
                    this.getEnabledDays(data);
                });
            }
        }).catch((error) => {
            console.log(error);
            this.props.changeAppLoading(false);
        })
    }

	queryStringCall(nextPage = false, sortChange = false) {
        var elem = document.getElementById("resultsContainer");
		var qsObj = {
			"search_engine": this.props.id,
			"search_value": this.state.searchValue,
            "page": this.state.page,
            "sort": this.state.sort.value,
        };
        if (this.state.playlistFilter) {
            if (this.state.playlistFilter.length != 0) {
                qsObj["playlist_name"] = this.state.playlistFilter;
            };
        }
        
        if (this.state.videoFilter) {
            if (this.state.videoFilter.hasOwnProperty("value")) {
                qsObj["video_id"] = this.state.videoFilter.value;
            }
            if (this.state.videoFilter.hasOwnProperty("doc_count")) {
                qsObj["video_title"] = this.state.videoFilter.key;
            }
        }

        if (!nextPage) {
            qsObj["page"] = 1;
            if (!sortChange) {
                qsObj["sort"] = "";
                this.setState({page: 1, sort: { value: '', label: 'Sort by Relevance' }})
            }
        }
        
        if (this.state.selectedDate) {
            if (this.state.selectedDate.hasOwnProperty("from") || this.state.selectedDate.hasOwnProperty("to")) {
                if (this.state.selectedDate.from !== undefined) {
                    qsObj["date_range"] = [
                        Math.floor(this.state.selectedDate.from.getTime() / 1000),
                        (this.state.selectedDate.to == undefined ? undefined : Math.floor(this.state.selectedDate.to.getTime() / 1000))  
                    ];
                }
            } else {
                qsObj["date"] = Math.floor(this.state.selectedDate.getTime() / 1000); 
            }
        };

		var qsString = qs.stringify(qsObj);
		this.setState({qs: qsObj, qsString: qsString, emptySearch: false});
        if (!nextPage) {
            this.setState({nextPageLoad: true, searchResults: []});
            elem.scrollTo(0, 0);
        }
        this.props.mixpanel.track("Searched", qsObj)
        this.search(nextPage);
    }
    
    nextPage() {
        this.setState({page: this.state.page += 1}, () => {
            this.queryStringCall(true);
        });
    }

    changeSort(value) {
        this.setState({sort:value}, () => {
            this.queryStringCall(false, true);
        })
    }

    videoAutoComplete(inputValue, callback) {
        if (inputValue) {
            if (inputValue.length > 2) {
                setTimeout(() => {
                    var qsString = qs.stringify({
                        search_engine: this.props.id,
                        search_value: inputValue
                    });
                    apiGetRequest("search/video-autocomplete?" + qsString).then((data) => {
                        callback(data);
                    });
                }, 333);
            }
        };
    }

    isFilterButtonDisabled() {
        return (this.state.playlistFilter == "" && this.state.videoFilter == "" && this.state.selectedDate == undefined || this.state.selectedDate == {from: undefined, to: undefined});
    }

    resetFilters() {
        this.setState({
            playlistFilter: "",
            videoFilter: "",
            selectedDate: undefined
        }, () => {
            this.queryStringCall();
        })
    }


	render() {
        let selectStyles = {
            menu: (provided, state) => ({
                ...provided,
                position: 'relative'
            })
        }
        if (this.state.loading) {
            return(
                <div />
            )
        } else {
            return (
                <div class={cx("home")}>
                    <Header />
    
                    <div class={cx("content")}>
                        <div class={cx("searchBarContainer")}>
                            <Back 
                                cta={"Back to Search Engine List"}
                                callback={() => {
                                    route("/search/list/")
                                }}
                            />
                            <h1>What do you want to find today?</h1>
                            <div class={cx("searchBar")}>
                                <form onSubmit={(e) => {
                                    e.preventDefault();
                                    this.queryStringCall()
                                }}>
                                    <Input 
                                        value={this.state.searchValue}
                                        onChange={(e) => this.setState({searchValue: e.target.value})}
                                        placeholder="Enter your search" 
                                    />
                                </form>
                            </div>
                        </div>
    
                        <div id="resultsContainer" class={cx("resultsContainer")}>
                            {!this.state.emptySearch && this.state.resultCount != 0 &&
                                <div class={cx("result-count")}>
                                    <p><small>About {this.state.resultCount.toLocaleString( { minimumFractionDigits: 4 })} results</small></p>
                                </div>
                            }

                            <div class={cx("sort")}>
                                <Dropdown 
                                    options={
                                        [
                                            { value: '', label: 'Sort by Relevance' },
                                            { value: 'published_at', label: 'Sort by Oldest' },
                                            { value: '-published_at', label: 'Sort by Newest' },
                                        ]
                                    } 
                                    onChange={(val) => this.changeSort(val)} 
                                    value={this.state.sort} 
                                    placeholder="Sort"
                                />
                            </div>

                            {this.state.emptySearch &&
                                <p><span style={{fontSize: "20px"}}>🤷</span> Couldn't find anything, try simplifying your search word(s) or reducing filters</p>
                            }

                            <section class={cx("results-section")}>
                                <FilterContainer 
                                    dateOption={this.state.dateOption}
                                    selectedDate={this.state.selectedDate}
                                    playlistFilter={this.state.playlistFilter}
                                    videoFilter={this.state.videoFilter}
                                    queryStringCall={() => this.queryStringCall()}
                                    isFilterButtonDisabled={() => this.isFilterButtonDisabled()}
                                    resetFilters={() => this.resetFilters()}
                                    searchEngine={this.state.searchEngine}
                                    setState={(val, cb) => this.setState(val, cb)}
                                    handleYearMonthChange={(month) => this.handleYearMonthChange(month)}
                                    videoAutoComplete={(inputValue, callback) => this.videoAutoComplete(inputValue, callback)}
                                    selectStyles={selectStyles}
                                    month={this.state.month}
                                    mixpanel={this.props.mixpanel}
                                    enabledDays={this.state.enabledDays}
                                    earliestDate={this.state.earliestDate}
                                    latestDate={this.state.latestDate}
                                    playlistFacets={this.state.playlistFacets}
                                    videoFacets={this.state.videoFacets}
                                />
                                <div class={cx("results-list")}>
                                    {this.state.searchResults.map((item, index) => (
                                        <SearchResultCard 
                                            item={item}
                                            key={index}
                                            mixpanel={this.props.mixpanel}
                                        />
                                    ))}
                                </div>
                            </section>
                            <section>
                                {this.state.searchResults.length !== 0 && this.state.pages > 1 && this.state.page !== this.state.pages && !this.state.nextPageLoad &&
                                    <div class={cx("loadMore")} onClick={() => this.nextPage()}>
                                        <p>Load More</p>
                                    </div>
                                }
                                {this.state.nextPageLoad && 
                                    <div id="loadIndicator" class={cx("nextPageLoad")}>
                                        <p class={cx("emoji")}>🔍</p>
                                        <p>Loading</p>
                                    </div>
                                }
                            </section>
                        </div>
                    </div>
                </div>
            );
        }
	}
}




// WEBPACK FOOTER //
// ./routes/search/search/index.js